import vetting_modal from './vetting_modal.js'
import pages from './pages.js'
import firebase from './firebase.js'

export default {
  app_name: 'Suitup Finance',
  operation_name: 'Finance',
  display_app_name: 'Suitup',
  stylesheet: '/finance.css',
  favicon: '/finance_favicon.png',
  base_api_url: 'https://finance.suitupapi.club/',
  // conv-svc / intake operation slug — routes the readonly chatbot panel to this tenant's API
  intake_operation_slug: 'rebase',
  preview_link: 'https://finance.suitup.website/offer_preview/',
  company_panel_url: 'https://finance.companies.suitup.co.il/',
  field: 'הפיננסי',
  recruitement_field: 'השמה בעולם הפיננסי',
  discrete_emoji: '🤩',
  icon: '⭐',
  files: {
    is_profile_default_checked: true
  },
  applicant_modal: {
    languages: ['אנגלית']
  },
  applicant_history_company_modal: {
    job_title_options: []
  },
  vetting_modal,
  pages,
  images: {
    logo_bright: '/suitup_logo_bright.png',
    logo_dark: '/suitup_logo_dark.png'
  },
  links: {
    website_url: 'https://www.suitup.co.il/',
    web_base_url: 'https://finance.suitup.website/',
    app_store_url: 'https://apps.apple.com/il/app/suitup-קריירה-משפטית/id1320598994',
    google_play_url: 'https://play.google.com/store/apps/details?id=io.suitup'
  },
  hashtags: 'suitup',
  firebase,
  full_env_name: 'suitup_finance_production'
}
